import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import expertsystem from "../../../Assets/Projects/ML/Pakar.png";
import expertsystem2 from "../../../Assets/Projects/ML/Pakar2.png";
import expertsystem3 from "../../../Assets/Projects/ML/Pakar3.png";
import expertsystem4 from "../../../Assets/Projects/ML/Pakar4.png";
import expertsystem5 from "../../../Assets/Projects/ML/Pakar5.png";
import expertsystem6 from "../../../Assets/Projects/ML/Pakar6.png";

function ExpertSystem() {
  return (
    <ProjectDetailCard
      title="Honey Guava Disease Diagnosis Expert System"
      image={expertsystem}
      screenshots={[expertsystem2, expertsystem3, expertsystem4]}
      description="
      Honey Guava Disease Diagnosis Expert System is a web-based intelligent application designed to assist farmers in identifying diseases affecting honey guava plants. The system applies the Certainty Factor method to evaluate symptoms entered by users and calculate the confidence level of each possible diagnosis. In addition to providing disease identification, the application offers treatment recommendations and preventive actions, enabling faster and more informed decision-making in agricultural management.
      "
      technologies={[
        "PHP",
        "CodeIgniter 4",
        "Certainty Factor",
        "MySQL",
        "JavaScript",
        "Bootstrap 5",
        "HTML5",
        "CSS3",
        "Git",
        "Expert System",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={expertsystem5} alt="gallery1" />
          <img src={expertsystem6} alt="gallery2" />
          <img src={expertsystem} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default ExpertSystem;
